import request from '@/utils/request'
import qs from 'qs'

// 供应商列表
export const getProviderList = (params) => {
  return request({
    url: '/api/deptSupplier',
    method: 'GET',
    params:params,
    paramsSerializer: params => {
      return qs.stringify(params, {indices: false})
    }
  })
}
// 新增供应商
export const addProvider = params => {
    return request({
      url: '/api/deptSupplier',
      method: 'POST',
      data: params
    })
}
//获取证书清单
export const getCertList = (id) => {
    return request({
      url: '/api/certificate/supplier/' + id,
      method: 'GET'
    })
}
// 删除供应商
export const deleteProvider = (id) => {
    return request({
      url: '/api/deptSupplier/'+ id,
      method: 'DELETE'
    })
}
// 解绑供应商
export const resolveProvider = (id) => {
  return request({
    url: '/api/deptSupplier/untie/'+ id,
    method: 'PUT'
  })
}
// 开启暂停供应商状态
export const statusChangeProvider = (id) => {
  return request({
    url: '/api/deptSupplier/changeState/'+ id,
    method: 'PUT'
  })
}
// 编辑供应商
export const editProvider = params => {
  return request({
    url: '/api/deptSupplier',
    method: 'PUT',
    data: params
  })
}
// 获取邀请信息
export const getCopyInfo = (id) => {
  return request({
    url: '/api/deptSupplier/copy/' + id,
    method: 'GET'
  })
}
// 获取供应商详情
export const getDetail = (id) => {
  return request({
    url: '/api/deptSupplier/' + id,
    method: 'GET'
  })
}
// 获取供应商列表
export const getProviderNameList = () => {
  return request({
    url: '/api/consistency/factoryName',
    method: 'GET'
  })
}
